let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lQ9xE")).then(() => parcelRequire('2Bgv8'));